import { module } from 'angular';
import * as React from 'react';
import { react2angular } from 'react2angular';
import CloudwatchWidget from './CloudwatchWidget';
import DatadogWidget from './DatadogWidget';
import { SlaDefinition } from './SlaDefinition'

class SlaConfigState {
  public slaDefinitions: SlaDefinition[]
}

interface SlaConfigProps {
  updateSlaDefinitions: any
  upstreamSlaDefinitions: any
}

export default class SlaConfig extends React.Component<SlaConfigProps, SlaConfigState> {
  constructor(props: any) {
    super(props);
    this.addCloudwatchDefinition = this.addCloudwatchDefinition.bind(this);
    this.addDatadogDefinition = this.addDatadogDefinition.bind(this);
    this.updateDefinition = this.updateDefinition.bind(this);
    if (this.props.upstreamSlaDefinitions) {
      this.state = { slaDefinitions: this.props.upstreamSlaDefinitions }
    } else {
      this.state = { slaDefinitions: [] }
    }
  }

  public addCloudwatchDefinition() {
    const a = this.state.slaDefinitions;
    const def = {
      uuid: new Date().getTime().toString(),
      limit: 0,
      comparator: '',
      metric: {
        type: 'cloudwatch',
        name: '',
        loadBalancer: {
          account: '',
          name: '',
          cloudProvider: 'aws',
          region: ''
        }
      }
    };
    a.push(def);
    this.setState({ slaDefinitions: a });
    this.props.updateSlaDefinitions(a);
  }

  public addDatadogDefinition() {
    const a = this.state.slaDefinitions;
    const def = {
      uuid: new Date().getTime().toString(),
      limit: 0,
      comparator: '',
      metric: {
        type: 'datadog',
        aggregator: '',
        name: '',
        tags: [] as string[]
      }
    };
    a.push(def);
    this.setState({ slaDefinitions: a });
    this.props.updateSlaDefinitions(a);
  }

  public updateDefinition(i: any, def: any) {
    const a = this.state.slaDefinitions;
    a[i] = def;
    this.setState({ slaDefinitions: a });
    this.props.updateSlaDefinitions(a);
  }

  public deleteDefinition(i: any) {
    const a = this.state.slaDefinitions;
    a.splice(i, 1);
    this.setState({ slaDefinitions: a });
    this.props.updateSlaDefinitions(a);
  }

  public render() {
    const metricRows = [];
    const self = this; // hack to get around lambdas in props issues.

    const numDefs = this.state.slaDefinitions.length
    for ( let i = 0; i < numDefs; i++ ) {
      const e = this.state.slaDefinitions[i];
      const updateDef = (slaDefinition: SlaDefinition) => self.updateDefinition(i, slaDefinition)
      const deleteDef = () => self.deleteDefinition(i)
      if (e.metric.type === 'cloudwatch') {
        metricRows.push(<div key={i.toString()} className="row"><CloudwatchWidget definition={e} updateDefinition={updateDef} deleteDefinition={deleteDef} numDefs={numDefs}/></div>);
      } else if (e.metric.type === 'datadog') {
        metricRows.push(<div key={i.toString()} className="row"><DatadogWidget definition={e} updateDefinition={updateDef} deleteDefinition={deleteDef} numDefs={numDefs}/></div>);
      }
    }
    return (
      <div>
        {metricRows}
        <div>
          <button className="btn btn-block btn-sm add-new" onClick={this.addCloudwatchDefinition}>
            <span className="glyphicon glyphicon-plus-sign"/>
            Add Cloudwatch SLA Metric
          </button>
        </div>
        <div>
          <button className="btn btn-block btn-sm add-new" onClick={this.addDatadogDefinition}>
            <span className="glyphicon glyphicon-plus-sign"/>
            Add Datadog SLA Metric
          </button>
        </div>
      </div>
    )
  }
}

export const PLATFORM_SLA_CONFIG = 'platform.sla.config';
const ngmodule = module(PLATFORM_SLA_CONFIG, []);
ngmodule.component('slaConfig', react2angular(SlaConfig, ['updateSlaDefinitions', 'upstreamSlaDefinitions']));
